<template>
  <div class="col-md-6">
     <cards class="previews-order-card">
      <div class="wrapper-previews-Item">
        <div class="box avatar image-container">
          <el-image class="logo" :src="order.location.logo">
              <div slot="placeholder" class="image-slot">
                <i class="fa fa-circle-o-notch fa-spin fa-1x fa-fw"></i>
              </div>
              <div slot="error" class="image-slot text">
                {{ order.location.name.substring(0, 2) | capitalize  }}
              </div>
            </el-image>
        </div>
        <div class="box price">
          <p>{{order.total_price | currency(currentCurrency)}}</p>
        </div>
        <div class="box order-status">
          <div class="order-status-grid">
          <p>{{getLastStatus(order).text}}</p>        
          <span :style="{'background-color':getLastStatus(order).color}" class="grid-dot dot" ></span>
          </div>  
        </div>
        <div class="box payment_type"><i :class="getHelpers.getPaymentTypeIcon(order.order_payment_type_id, true)"></i></div>
        <div class="box date">{{getHelpers.generateFormatedDateTime(order.created_at, "date" , "DD MMM YYYY  HH:mm")}}</div>
        <div class="box counter"><i class="k-icon-basket-2"></i> {{ $t('text.counter_items', {counter: order.orderItems.length}) }} </div>
        <div class="box items">
        <el-collapse >
          <el-collapse-item>
          <template slot="title"><div v-html="getHelpers.getViewOrderTitle(order.id , order.order_type)"></div></template>
            <div  v-for="(item, index) in order.orderItems" :key="index"  >
              <div v-if="item.menuItem" class="item">
                <div class="quantity">{{item.quantity}}</div>
                <div class="name">{{item.menuItem.name}}</div>
                <div class="price">{{ item.price | currency(currentCurrency)}}</div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>

        </div>

        </div>
        <div class="box buttons" v-if="isAuthenticated">
          <el-button :class="{'col-md-4':!getHelpers.orderHasDeletedMenuItems(order),'col-md-12':getHelpers.orderHasDeletedMenuItems(order)}" 
          @click="onViewStatusClick(order)">{{ $t('button.view_status') }}</el-button>
          <el-button  :disabled="(order.review != null || order.order_status !== enumHelper.orderStatus.COMPLETED)" 
          class="col-md-4" v-if="!getHelpers.orderHasDeletedMenuItems(order)"  @click="addReview(order)">{{$t('button.leave_review')}}</el-button> 
          <el-button class="col-md-4" @click="onViewOrderDetailsClick(order)" v-if="!getHelpers.orderHasDeletedMenuItems(order)"  >{{ $t('button.view_order') }}</el-button> 
        </div>
    </cards>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { Button, Cards } from "@/components";
import { helpers, enumHelper } from "@/utilities";
export default {
  name:'previous-order-item',
  components: {
    [Button.name]: Button,
    Cards
  },
  data() {
    return {
      getHelpers : helpers,
      enumHelper : enumHelper,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    ...mapGetters(["isAuthenticated"]),
    getLastStatus() {
      return(order)=>{
        return helpers.getLastOrderStatus({order_status: order.order_status});
      }
    },
  },
  methods: {
    addReview(_item) {
        this.$root.$emit("PUSH_REVIEW",{save:false, order:_item} );
    },
    onViewStatusClick : function(order){
      let objOrder = {
        id: order.id,
        where2_enabled:order.where2_enabled,
        location: order.location,
        orderWhere2: order.orderWhere2,
        order_type: order.order_type,
        order_status : order.order_status,
        orderStatusHistory: order.orderStatusHistory
      }
      this.$root.$emit("VIEW_STATUS",objOrder );
    },
    onViewOrderDetailsClick: function(order){
      this.$emit("orderDetailsClicked", order)
    },
  },
  props: {
    order: Object,
    small: Boolean
  }
};
</script>
